import {
    BaseRelationalServerKey,
    NegationOperator,
    RelationalServerKey,
    ServerKey,
} from 'components/filter/types';
import { FilterCacheKey } from 'types/filter-cache-key';

const hasPossibleNegationOperator = (
    key: ServerKey,
    relationalServerKey: RelationalServerKey,
): boolean => {
    switch (relationalServerKey) {
        case 'has_campaign_members':
            return getMemberNegationKeys(key);
        case 'has_transactions':
            return getTransactionNegationKeys(key);
        case 'has_transaction_plans':
            return getTransactionPlanNegationKeys(key);
        case 'has_tickets':
            return getTicketNegationKeys(key);
        case 'has_pledges':
            return getPledgeNegationKeys(key);
        default:
            return false;
    }
};

const getMemberNegationKeys = (key: ServerKey) => {
    switch (key) {
        case 'raised':
        case 'goal':
        case 'donors':
        case 'created_at':
            return true;
        default:
            return false;
    }
};

const getTransactionPlanNegationKeys = (key: ServerKey) => {
    switch (key) {
        case 'amount':
        case 'startAt':
        case 'nextBillDate':
            return true;
        default:
            return false;
    }
};

const getTransactionNegationKeys = (key: ServerKey) => {
    switch (key) {
        case 'created_at':
        case 'amount':
            return true;
        default:
            return false;
    }
};

const getTicketNegationKeys = (key: ServerKey) => key === 'created_at';

const getPledgeNegationKeys = (key: ServerKey) => {
    switch (key) {
        case 'total':
        case 'firstInstallmentDate':
        case 'nextInstallmentDate':
        case 'fullfillmentDate':
            return true;
        default:
            return false;
    }
};

const baseRelationalKeyToCacheKey = (
    baseRelationalKey: BaseRelationalServerKey,
): FilterCacheKey => {
    switch (baseRelationalKey) {
        case 'campaign_members':
            return 'contacts';
        case 'transaction_plans':
            return 'plans';
        case 'tickets':
        case 'pledges':
        case 'transactions':
            return baseRelationalKey;
    }
};

const getCacheKeyFromRelationalKey = (relationalServerKey: RelationalServerKey) =>
    baseRelationalKeyToCacheKey(getResourceFromRelationalKey(relationalServerKey));

const getResourceFromRelationalKey = (key: RelationalServerKey) =>
    key.replace(/^(has_|doesnt_have_)/, '') as BaseRelationalServerKey;

const getReadableRelationalResource = (value: string) => {
    if (value === 'transaction_plans') {
        return 'recurring plans';
    }
    return value.replace('_', ' ');
};

const transformRelationalResourceToReadable = (key: RelationalServerKey) =>
    getReadableRelationalResource(getResourceFromRelationalKey(key));

const transformNegationOperatorToReadable = (operator: NegationOperator) => {
    if (operator === 'has') {
        return 'has';
    }

    return `doesn't have`;
};

export {
    getResourceFromRelationalKey,
    hasPossibleNegationOperator,
    transformNegationOperatorToReadable,
    getReadableRelationalResource,
    transformRelationalResourceToReadable,
    baseRelationalKeyToCacheKey,
    getCacheKeyFromRelationalKey,
};
